<template>
  <Transition name="loader" appear>
    <section
      v-if="visible"
      class="loader"
      role="status"
      aria-live="polite"
      aria-label="Loading portfolio"
      :aria-busy="visible"
    >
      <div class="loader__content">
        <div class="loader__text">
          <span class="loader__letter" v-for="(letter, i) in 'KLAUDIA STOKLOSA'" :key="i" :style="{ animationDelay: `${i * 0.05}s` }">
            {{ letter === ' ' ? '\u00A0' : letter }}
          </span>
        </div>

        <div class="loader__bar">
          <span class="loader__bar-fill" />
        </div>

        <p class="loader__subtitle">Interior Designer</p>
      </div>
    </section>
  </Transition>
</template>

<script>
export default {
  name: 'PageLoader',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.loader {
  position: fixed;
  inset: 0;
  background: #000000;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20000;
  overflow: hidden;
  pointer-events: auto;
  font-family: "Courier New", monospace;

  &__content {
    position: relative;
    text-align: center;
  }

  &__text {
    font-size: clamp(20px, 4vw, 48px);
    font-weight: 100;
    letter-spacing: 0.2em;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
    gap: 0.05em;
  }

  &__letter {
    display: inline-block;
    opacity: 0;
    animation: letterFade 0.6s ease forwards;
  }

  &__bar {
    width: min(400px, 80vw);
    height: 1px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.15);
    position: relative;
    overflow: hidden;
  }

  &__bar-fill {
    position: absolute;
    inset: 0;
    background: white;
    transform: translateX(-100%);
    animation: barFill 2.5s ease-out forwards;
  }

  &__subtitle {
    margin-top: 40px;
    font-size: 11px;
    letter-spacing: 0.3em;
    color: rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
    opacity: 0;
    animation: subtitleFade 0.8s ease 0.3s forwards;
  }
}

.loader-enter-active,
.loader-leave-active {
  transition: opacity 0.5s ease;
}

.loader-enter-from,
.loader-leave-to {
  opacity: 0;
}

@keyframes letterFade {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes barFill {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes subtitleFade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (max-width: 640px) {
  .loader__text {
    letter-spacing: 0.15em;
    margin-bottom: 40px;
  }

  .loader__subtitle {
    letter-spacing: 0.25em;
    font-size: 10px;
  }
}
</style>